const ACTIONS = {
    GET: "get",
  };
  
  export { ACTIONS };
  